"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayersvoteAnalytics = void 0;
var PlayersvoteAnalytics;
(function (PlayersvoteAnalytics) {
    var Category;
    (function (Category) {
        Category["GameInteraction"] = "gameInteraction";
        Category["PollInteraction"] = "pollInteraction";
        Category["SponsorInteraction"] = "sponsorInteraction";
        Category["Message"] = "message";
        Category["Users"] = "users";
    })(Category = PlayersvoteAnalytics.Category || (PlayersvoteAnalytics.Category = {}));
    var Action;
    (function (Action) {
        // Game Interactions
        Action["Predict"] = "predict";
        Action["Rate"] = "rate";
        Action["View"] = "view";
        Action["Notify"] = "notify";
        // Users
        Action["Register"] = "register";
        Action["TotalRegistrations"] = "totalRegistrations";
        Action["ActiveUsers"] = "activeUsers";
        Action["Delete"] = "delete";
        // Messages
        Action["Incoming"] = "incoming";
        Action["Outgoing"] = "outgoing";
        // Sponsors
        Action["Deliver"] = "deliver";
        Action["Click"] = "click";
    })(Action = PlayersvoteAnalytics.Action || (PlayersvoteAnalytics.Action = {}));
    var DashboardStatGranularity;
    (function (DashboardStatGranularity) {
        DashboardStatGranularity["League"] = "league";
        DashboardStatGranularity["Tournament"] = "tournament";
        DashboardStatGranularity["All"] = "all";
    })(DashboardStatGranularity = PlayersvoteAnalytics.DashboardStatGranularity || (PlayersvoteAnalytics.DashboardStatGranularity = {}));
    function createCategoryString(accountId, category) {
        return "".concat(accountId, ":").concat(category);
    }
    PlayersvoteAnalytics.createCategoryString = createCategoryString;
    function createPollInteractionCategoryString(accountId, origin) {
        return createCategoryString(accountId, "".concat(Category.PollInteraction, ":").concat(origin));
    }
    PlayersvoteAnalytics.createPollInteractionCategoryString = createPollInteractionCategoryString;
    function createGameInteractionCategoryString(accountId, origin) {
        return createCategoryString(accountId, "".concat(origin, ":").concat(Category.GameInteraction));
    }
    PlayersvoteAnalytics.createGameInteractionCategoryString = createGameInteractionCategoryString;
    function createSponsorInteractionCategoryString(accountId, origin) {
        return createCategoryString(accountId, "".concat(Category.SponsorInteraction, ":").concat(origin));
    }
    PlayersvoteAnalytics.createSponsorInteractionCategoryString = createSponsorInteractionCategoryString;
    function createGameEventLabel(league, source, gameId) {
        var parts = [
            league.classification, league.sport_type, league.analytics_key
        ];
        if (source) {
            parts.push(source.key);
        }
        if (gameId) {
            parts.push(gameId);
        }
        return parts.join(':');
    }
    PlayersvoteAnalytics.createGameEventLabel = createGameEventLabel;
})(PlayersvoteAnalytics = exports.PlayersvoteAnalytics || (exports.PlayersvoteAnalytics = {}));
